import { useEffect } from 'react';

const TikTokPixel = () => {
    useEffect(() => {
        // Load the TikTok Pixel script
        (function (w, d, t) {
            w.TiktokAnalyticsObject = t;
            const ttq = (w[t] = w[t] || []);
            ttq.methods = [
                'page',
                'track',
                'identify',
                'instances',
                'debug',
                'on',
                'off',
                'once',
                'ready',
                'alias',
                'group',
                'enableCookie',
                'disableCookie',
                'holdConsent',
                'revokeConsent',
                'grantConsent',
            ];
            ttq.setAndDefer = function (t, e) {
                t[e] = function () {
                    t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                };
            };
            for (let i = 0; i < ttq.methods.length; i++) {
                ttq.setAndDefer(ttq, ttq.methods[i]);
            }
            ttq.instance = function (t) {
                const e = ttq._i[t] || [];
                for (let i = 0; i < ttq.methods.length; i++) {
                    ttq.setAndDefer(e, ttq.methods[i]);
                }
                return e;
            };
            ttq.load = function (pixelId, options) {
                const script = d.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.src = `https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${pixelId}&lib=${t}`;

                const firstScript = d.getElementsByTagName('script')[0];
                firstScript.parentNode.insertBefore(script, firstScript);

                ttq._i = ttq._i || {};
                ttq._i[pixelId] = [];
                ttq._i[pixelId]._u = script.src;
                ttq._t = ttq._t || {};
                ttq._t[pixelId] = +new Date();
                ttq._o = ttq._o || {};
                ttq._o[pixelId] = options || {};
            };

            ttq.load(process.env.REACT_APP_TIKTOK_PIXEL_ID);
            ttq.page();
        })(window, document, 'ttq');
    }, []);

    return null;
};


export const trackTikTokEvent = (eventName, data = {}) => {
    if (typeof window.ttq !== 'undefined') {
      window.ttq.track(eventName, data);
    } else {
      console.warn(`[TikTok] Event "${eventName}" not fired — ttq not available`);
    }
  };

export default TikTokPixel;
